import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {GeneratePaymentProfilesButton} from "../../test-data-generator/buttons/GeneratePaymentProfilesButton.tsx";


const useTools = ({ customerId, billingProviderId }: { customerId?: string; billingProviderId?: string }) => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [];

    tools.push(<ReloadRecordsButton key='reload'/>);

    if (allowedActions.includes(rbacActions.DeletePaymentProfile)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreatePaymentProfile)) {
        tools.push(<AddRecordButton key='add' customerId={customerId} billingProviderId={billingProviderId}/>);
        tools.push(<GeneratePaymentProfilesButton key='generate'/>);
    }


    return tools;
};

export const IndexPageHeader = ({ customerId, billingProviderId }: { customerId?: string; billingProviderId?: string }) => {
    return (
        <SimplePageHeader
            title={I18n.get('Payment Profiles')}
            tools={useTools({ customerId, billingProviderId })}
        />
    );
};